var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhonepay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_363",
    transform: "scale(0.0357143)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_363",
    width: 28,
    height: 28,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAACZ0lEQVRIDe2Wy08TURTG+YdARGNQcYVb49aF6EKKjaR24WOjG4ym4HNhXLg0VaNiTFyY0FoEUiFVErUEOsWNL4KhUExLWvtg+jnfpUM7M3eGEbG64CSTub1zz/nNOfc7d9qEBltTg3n4f4E/UgVEn80heCmBO/4pcXHMOT5zaxtmmFksItinwLd3BN62CE62hQ0X5/iMa7h2I3MEJieXcf7g6xpgVxg3PJO4cCiKnp2h2nz1JbiWPk5mC1TepuHfP2YI2tMaQnwshfT3n/Dts2bL7OlDXzuTAjNLRS2zqAGml/JM5wiyy0VEHnyGZ4c1S66jL2PITArkfugA852lvO17h1JRxeUjE7brGENmFiAVRxHUg7za3gW6Yhg4/kZcgaMxxF7M44uSQf+xtbmznaMGH8aQqdcCpMzNavQfGEZ+pQxVrUBdraCQK6OQX0W5pKJSgRg/DCiakGoKZgzGMpsFGOxLGN50PVMty0QsjfhoCt7dYfS2R/D01ixyKyWc7hgGq7C+tqpaxjKbBcimNjvy94nmIcxMLOH9qwV0twyJbB5fSyKXLeHUnpdSH8Yy278H2pWUGU6PL4o+5Jg9KUrqkKGrkspEw5Ky58L3PgnBDN6cxf0rM0jP521L6lo0srbQ95Sny/jzOSx8zeHbxyw+aAKy20PXbcFNdmp8ZurRytndEsKjq4ot0HXjE+h0tOnZsueeXE+K/jSr9LePNkJlh7cOE3cNePFwFHfPxQ0tsanDm0Ca5fNUbWgDuG7ujz5Pa0itvI38AOtQ3qletsxf/4tRD92KseVo24qgTjG2gU7V2dSzXx9RhstVnBgAAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonepay);
export default __webpack_public_path__ + "static/media/phonepay.1329d6a7798cec817759433d478924c0.svg";
export { ForwardRef as ReactComponent };